import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border: 1px solid #E3E3E3;
    position: relative;

    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 8px;

    padding: 12px;

    padding-left: ${p => p.hasPhoto ? '35px' : '12px'};

    ${p => p.focused && css`
      border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
    `}
    
    &:hover {
      border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
    }
  `}
`;
